import React from 'react';
import { withTranslation } from 'react-i18next';

const ZoomBanner = ({ meetingId, t, onJoin }) => {
    if (!meetingId) {
        return null;
    }

    return (
        <div className="discussion-zoom-banner">
            { t('There\'s an ongoing Zoom Meeting') }

            <button className="btn btn-secondary btn-small" onClick={onJoin}>{ t('Join Meeting') }</button>
        </div>
    )
}

export default withTranslation('chat')(ZoomBanner);

